import styled from 'styled-components'
import { colors } from '../../Global/Styles/variables'
import SelectRole from './SelectRole'
import { useGlobalState } from 'src/Global/GlobalContext'

const SwitchRole = () => {
  const globalState = useGlobalState()
  const { setEMRAuthState } = globalState

  const onCloseModal = () => {
    setEMRAuthState({
      ...globalState,
      redirectToAfterRoleSelection: null,
    })
  }

  return (
    <SwitchRoleContainer>
      <SelectRolesContainer>
        <Title>Switch role</Title>
        <InfoText>Please pick a role to switch to:</InfoText>
        <SelectRole
          onCancel={() => onCloseModal()}
          cancelButtonText="Cancel"
          confirmButtonText="Switch role"
        />
      </SelectRolesContainer>
    </SwitchRoleContainer>
  )
}

const InfoText = styled.div`
  color: ${colors.brightGrey};
  font-size: 1rem;
  margin: 25px 0;
`

const Title = styled.div`
  font-size: 36px;
  font-weight: bold;
`

const SelectRolesContainer = styled.div`
  width: 500px;
  height: 276px;
`

const SwitchRoleContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
  font-family: 'Lato', sans-serif;
  justify-content: center;
  align-items: center;
`

export default SwitchRole
